var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Datatable',{attrs:{"headers":_vm.headers,"items":_vm.items,"title":"Vendor history","loading":_vm.$store.state.agency_vendor.fetching.history},on:{"search":function($event){_vm.search = $event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }